<template>
  <div>
    <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>

    <tablita :cols="columnas" @cargar="cargar($event)" @cargar_url="cargar_url($event)" @nuevo="crear"
      @editar="editar($event)" @editar_tarifas="editar_tarifas($event)" @subir_resolucion="abrir_modal_resolucion($event)"
      @visualizar_resolucion="visualizar_resolucion($event)" @visualizar_hermeticidad="visualizar_hermeticidad($event)" @visualizar_resolucion_acoplado="visualizar_resolucion_acoplado($event)"
      :configuracion="configuracion_tabla" @refresh="refrescar($event)" @generar_pdf="generar_pdf($event)"></tablita>

    <div class="modal fade" id="modalsubirarchivo" data-backdrop="static" data-keyboard="false" tabindex="-1"
      role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div :class="`modal-dialog modal-dialog-centered modal-md`" role="document" style="width:80%">
        <div class="modal-content">
          <div class="modal-header" style="background-color:#172b4d;">
            <h5 class="modal-title" id="exampleModalLabel" style="color:#fff">Subir Resolucion Sanitaria</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clear">
              <span aria-hidden="true" style="color:#fff;font-size:1.2em">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <!-- alert success -->
            <div :class="`alert ${alert.class} alert-dismissible fade show`" role="alert" v-if="alert.show">
                <span class="alert-icon"><i :class="`mr-4 ${alert.icon}`"></i>{{ alert.message }}</span> <br>
                <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <input @change="fileChange" type="file" id="file" accept="application/pdf" />
          </div>

          <div class="modal-footer">
            <button :disabled="noFiles" type="button" class="btn btn-primary" @click="subir_resolucion">Subir</button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../../components/Modal/ModalEditarCrear";
import Tabla from "../../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "Id",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "id",
      },
      {
        key: "patente",
        label: "Patente",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "patente",
      },
      {
        key: "empresas_id",
        label: "Empresa",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "empresa.nombre",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tipo_transportes_id",
        label: "Tipo Transporte",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "tipo_transporte.nombre",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "tipo_carrocerias_id",
        label: "Tipo Carroceria",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "tipo_carroceria_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "es_arrendado",
        label: "Arrendado",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "arrendado",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "label",
      },
      {
        key: "rendimiento_optimo",
        label: "Rendimiento Óptimo",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "rendimiento_optimo",
      },
      {
        key: "patente_acoplado",
        label: "Patente Acoplado",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "patente_acoplado",
      },
      {
        key: "hermeticidad_hasta",
        label: "Vigencia Hermeticidad",
        busqueda: "",
        tipo: "date",
        searchable: false,
        path: "hermeticidad_hasta",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Tarifas Arriendo",
        clase: "btn-success",
        evento: "editar_tarifas",
        icono: "fas fa-dollar-sign",
        condicion: "mostrar_tarifa",
      },
      {
        label: "Subir Resolucion",
        clase: "btn-submit",
        evento: "subir_resolucion",
        icono: "fas fa-upload",
        condicion: "",
      },
      {
        label: "Resolucion Camión",
        clase: "btn-danger",
        evento: "visualizar_resolucion",
        icono: "fas fa-file-pdf",
        condicion: "mostrar_resolucion",
      },
      {
        label: "Certificado Hermeticidad",
        clase: "btn-danger",
        evento: "visualizar_hermeticidad",
        icono: "fas fa-file-pdf",
        condicion: (item) => item.certificado_hermeticidad_url !== null,
      },
      {
        label: "Resolucion Acoplado",
        clase: "btn-danger",
        evento: "visualizar_resolucion_acoplado",
        icono: "fas fa-file-pdf",
        condicion: (item) => item.resolucion_acoplado_url !== null,
      },
    ],
    lista: [],
    current: null,
    alert: {
      show: false,
      message: "",
      class: "",
      icon: "",
    },
    errores: {},
    noFiles: true,
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "patente",
        valor: "",
        label: "Patente (*)",
        disabled: true,
      },
      {
        cols: 4,
        tipo: "select",
        key: "empresas_id",
        valor: "",
        label: "Seleccione Empresa (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select",
        key: "tipo_transportes_id",
        valor: "",
        label: "Seleccione Tipo Transporte",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select",
        key: "tipo_carrocerias_id",
        valor: "",
        label: "Seleccione Tipo Carroceria",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select",
        key: "es_arrendado",
        valor: "",
        label: "Es Arrendado",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "label",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "patente_acoplado",
        valor: "",
        label: "Patente Acoplado",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "datetime",
        key: "hermeticidad_desde",
        valor: "",
        label: "Hermeticidad Desde",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "datetime",
        key: "hermeticidad_hasta",
        valor: "",
        label: "Hermeticidad Hasta",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "rendimiento_optimo",
        valor: "",
        label: "Rendimiento Optimo",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "file",
        key: "certificado_hermeticidad",
        valor: "",
        label: "Certificado Hermeticidad",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "file",
        key: "resolucion_acoplado",
        valor: "",
        label: "Resolucion Acoplado",
        disabled: false,
      },
      
      {
        cols: 12,
        tipo: "texto",
        key: "observaciones",
        valor: "",
        label: "Observaciones",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Transporte",
      ancho: "xl",
      ruta: "/transportes",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Transportes",
      titulo_boton: "Crear Transporte",
      clase_boton: "btn-primary",
      btn_nuevo: true,
      mostrar_pdf:true
    },
    pagina_actual: "",
    tipo_transportes: [],
    tipo_carrocerias: [],
    arrendado_opciones: [
      { id: 1, label: "Si" },
      { id: 0, label: "No" },
      { id: 2, label: "Spot P" },
    ],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.cargar_tipo_carrocerias();
    this.columnas[5].opciones = this.arrendado_opciones;
    this.inputs[4].opciones = this.arrendado_opciones;
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    generar_pdf(event){
      console.log('pdf',event)
      this.axios.post(`${this.api}/generar_pdf/camiones`, event, this.cabeceras_json)
          .then((res) => {
            console.log('res',res.data)
            window.open(res.data.url,'_blank')
          })
    },
    abrir_modal_resolucion(item) {
      $('#modalsubirarchivo').modal({ show: true })
      this.current = item.item;
      
    },
    subir_resolucion() {
      
      let file = document.getElementById('file').files[0];
      // console.log(this.current.patente);
      if (file && file.type === 'application/pdf') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('id', this.current.id);
        // console.log(formData);

        this.axios.post(`${this.api}/uploadResolucion`, formData, this.cabeceras_archivo)
          .then((res) => {
            // console.log('archivo subido correctamente', res.data);
            // this.current = null; tiene que ser cuando cierre el modal
            this.errores = {};
            this.alert.message = 'Archivo subido correctamente';
            this.alert.class = 'alert-success';
            this.alert.icon = 'fas fa-check'
            this.alert.show = true;
            // this.$emit('realizado');
            document.getElementById('file').value = '';
            this.noFiles = true;
            
            this.refrescar();
          })
          .catch(() => {
            console.log('falló la subida del archivo ');
            this.alert.message = 'No se pudo subir el archivo';
            this.alert.class = 'alert-danger';
            this.alert.icon = 'fas fa-exclamation-triangle'
            this.alert.show = true;

            // console.log('error validacion', res.data); 
          });
      }

    },
    visualizar_resolucion(item) {
      //this will check if the item in that index hnas archivo_resolucion i database
      //if it has registry in database it will show the button and if not it will hide the button
      //the button must show the file located in the backend public folder resolucion_transportes

      window.open(item.item.link_resolucion, "_blank");
    },
    visualizar_hermeticidad(item) {
      window.open(item.item.certificado_hermeticidad_url, "_blank");
    },
    visualizar_resolucion_acoplado(item) {
      window.open(item.item.resolucion_acoplado_url, "_blank");
    },
    clear(){
      this.current = null;
      this.alert.show = false;
      this.alert.message = '';
      this.alert.class = '';
      // the upload file input is cleared
      this.noFiles = true;
      document.getElementById('file').value = '';

    },
    fileChange(event) {
      this.noFiles = !event.target.files.length;
    },
    async cargar_tipo_carrocerias() {
      await this.axios
        .get(`${this.api}/tipo_carrocerias`, this.cabeceras_json)
        .then((res) => {
          ////console.log('tipos',res.data.data.data);
          this.tipo_carrocerias = res.data.data.data;
          this.$set(this.columnas[4], "opciones", res.data.data.data);
          this.$set(this.inputs[3], "opciones", res.data.data.data);
          //this.cargar_empresas("");
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_tipo_transportes();
    },
    async cargar_tipo_transportes() {
      await this.axios
        .get(`${this.api}/tipo_transportes?limit=9999`, this.cabeceras_json)
        .then((res) => {
          // console.log('tipos',res.data.data.data);
          this.$set(this.columnas[3], "opciones", res.data.data.data);
          this.$set(this.inputs[2], "opciones", res.data.data.data);
          //this.cargar_empresas("");
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_empresas("");
    },

    async cargar_empresas() {
      await this.axios
        .get(
          `${this.api}/empresas?tipo_empresa_ids=2&limit=999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.$set(this.columnas[2], "opciones", res.data.data.data);
          this.$set(this.inputs[1], "opciones", res.data.data.data);
          //this.cargar("");
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("cargar");
    },

    async cargar($event) {
      this.lista = [];
      this.pagina_actual = `${this.api}/transportes${$event}`;
      await this.axios
        .get(`${this.api}/transportes${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          // console.log('listado: ',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.inputs[0].disabled = false;
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/transportes`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.inputs[0].disabled = true;
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/transportes/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    editar_tarifas(evento) {
      this.$router.push({
        name: "transportes_tarifas",
        params: { transportes_id: evento.item.id },
      });
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json", "cabeceras_archivo"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },

    path() {
      return this.$router.currentRoute.path;
    },

    mensaje() {
      let devolver = [];
      if (this.errores instanceof Object) {
          Object.keys(this.errores).forEach(key => {
              let array = this.errores[key];
              array.forEach(mensaje => {
                  devolver.push(mensaje);
              });
          });
      } else {
          this.errores.forEach(m => {
              devolver.push(m);
          });
      }

      return devolver;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>